/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export const API_MOCK_BASE_URL = 'http://api-base.local/'
export const API_MOCK_LOCALISATION_BASE_URL = 'https://localisation-base.local/'
